import type { Cents } from "@glastotaal/core";

const eur = new Intl.NumberFormat("nl-NL", {
  style: "currency",
  currency: "EUR",
});

/** Formats integer cents as a Dutch euro string, e.g. 25815 → "€ 258,15". */
export function formatEuro(cents: Cents): string {
  return eur.format(cents / 100);
}

/** Duizendtallen met een punt, zoals we maten in lopende tekst schrijven: 1500 → "1.500". */
export function formatDuizend(n: number): string {
  return new Intl.NumberFormat("nl-NL").format(n);
}

/** Formats millimetres, e.g. 1020 → "1020 mm". */
export function formatMm(mm: number): string {
  return `${mm} mm`;
}

/**
 * Tekstgrootte-klasse voor een prominent euro-bedrag, kleiner naarmate het bedrag langer is —
 * zo valt een groot totaal (€ 1.000, € 10.000) op smalle schermen niet meer buiten z'n box.
 * `sizes` = [klein-bedrag, ≥€1.000 (4 cijfers), ≥€10.000 (5+ cijfers)].
 */
export function euroSizeClass(cents: Cents, sizes: [string, string, string] = ["text-xl", "text-lg", "text-base"]): string {
  const euros = Math.abs(cents) / 100;
  if (euros >= 10000) return sizes[2];
  if (euros >= 1000) return sizes[1];
  return sizes[0];
}
